import Component from '../Component';
import React from 'react';
import {Select} from 'reactis-inputs';
import {connect} from 'react-redux';

@connect((state, props) => {
	return {
		options: state.dbinfo.trainingType
	};
})
export default class TrainingTypeSelect extends Component {

	render() {
		return (
			<Select {...this.props} options={this.props.options} />
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Form/TrainingTypeSelect.js